import { useSelector } from 'react-redux';

export const FindLoad = (status) => {
    const { httpOnLoad } = useSelector((state) => ({
        httpOnLoad: state.httpOnLoad,
    }));
    return httpOnLoad?.length && httpOnLoad.filter((i) => i?.loadingType === status);
};

export const FindLoadItem = (status) => {
    const { httpOnLoad } = useSelector((state) => ({
        httpOnLoad: state.httpOnLoad,
    }));
    return httpOnLoad?.length && httpOnLoad.find((i) => i?.loadingType === status);
};
